import { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { MAIN_COLORS } from '../../consts/colors'

interface IProps{
    children: string | ReactNode
    onClick:()=>void
    style?: any
    isLoading?: boolean
    mini?: boolean
}

const Btn = styled.button<{isLoading?: boolean, mini?: boolean}>`
    padding: 10px 12px;
    border-radius: 10px;
    background: ${props => props.isLoading ? `${MAIN_COLORS.purple_300}` : `${MAIN_COLORS.purple_200}`};
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${props => props.isLoading ? `${MAIN_COLORS.purple_300}` : '#ffffff'};
    border: none;

    ${p => p.mini && `
        color: ${MAIN_COLORS.purple_500};
    `}

    &:active {
        background-color: ${MAIN_COLORS.purple_300};
    }
`

const Button:FC<IProps> = ({ isLoading, children, onClick, mini, style }) => {
    
  return (
    <Btn onClick={onClick} mini={mini} isLoading={isLoading} style={{ ...style }}>
      {children}
    </Btn>
  )
}

export default Button
